import { createSlice } from '@reduxjs/toolkit';
import { http } from '../../Lib/Http/httpClient';
export var UserReducer = createSlice({
    name: 'user',
    initialState: {
        data: null
    },
    reducers: {
        set: function set(state, user) {
            state.data = user.payload.data;
            http.token = user.payload.token;
        },
        del: function del(state) {
            http.token = '';
            state.data = null;
        }
    }
});
var _UserReducer$actions = UserReducer.actions, set = _UserReducer$actions.set, del = _UserReducer$actions.del;
export { set, del };
export default UserReducer.reducer;
